export const isAcorisRiaBlocked = ({
  hasOtherInsurer,
  contractOlderThanOneYear,
}) => hasOtherInsurer === true && contractOlderThanOneYear === false;

export const applyAcorisRiaOlderThanOneYearTest = (schema, message) =>
  schema.test("ria-under-one-year", message, (value) => value !== false);
